import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import PlacementForm from '../components/PlacementForm';
import PlacementsTable from '../components/PlacementsTable';
import { ORG_LABELS } from '../config';
import { Alert, Button, Card } from '../ui/basics';

export default function Placements() {
  const { org, user, hasPage } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(null); // null | { placement? }
  const [version, setVersion] = useState(0);
  const canEdit = user.can_edit;

  return (
    <div className="stack">
      <div className="page-head">
        <div><h1>Placements</h1><p>{ORG_LABELS[org]} · every placement you have access to</p></div>
        <div className="actions">
          {canEdit && hasPage('onboardings') && <Button variant="primary" onClick={() => navigate('/onboardings')}>Convert an offer</Button>}
          {canEdit && user.is_admin && <Button icon="plus" onClick={() => setForm({ override: true })}>Add without an offer</Button>}
        </div>
      </div>
      {canEdit && (
        <Alert tone="info">
          Placements are created by converting a candidate offer. Open the offer in Onboardings, collect its documents and choose Convert to placement.
          {user.is_admin ? ' As an administrator you can also add a historical placement without an offer.' : ''}
        </Alert>
      )}
      <Card flush>
        {/* key remounts the table (and its filters) when the organization changes or a row is saved */}
        <PlacementsTable key={`${org}-${version}`} fixed={{ organization: org }} onRowClick={canEdit ? (row) => setForm({ placement: row }) : undefined} />
      </Card>
      {form && (
        <PlacementForm placement={form.placement} override={form.override} defaultOrg={org} onClose={() => setForm(null)}
          onSaved={() => { setForm(null); setVersion((v) => v + 1); }} />
      )}
    </div>
  );
}
